export default "__VITE_ASSET__a1AH6gl3__"